import { Component, ViewEncapsulation } from '@angular/core';
import { LoginService } from '@features/login/services/login.service';
@Component({
  selector: 'app-mfa-otp',
  templateUrl: './mfa-otp.component.html',
  styleUrls: ['./mfa-otp.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MfaOtpComponent {
  constructor(private loginService: LoginService) {}

  submitMfaOtp(input: string) {
    if (!!input && input.length === 6) {
      this.loginService.startSession({ mfa_otp: input });
    }
  }
}
